import React from "react";
import intl from 'react-intl-universal';
import {
    Row,
    Col,
    Checkbox,
    InputNumber,
 } from 'antd';
const localStorageKey = "PREFERENCES-GENNERAL";
const localStorageSettings = {
        singleKey: false,
        fixedResolution: false,
        resolution: 72,
        creatLinkFromUrls: true,
        handSelectText: true,
        handReadArticles: true,
        handUseMouseZoom: false,
}
if(!window.localStorage.getItem(localStorageKey)) {
    window.localStorage.setItem(localStorageKey, JSON.stringify(localStorageSettings));
}
export default class Genneral extends React.Component {
    constructor(props) {
        super(props);
        const local = window.localStorage.getItem(localStorageKey);
        if(local) {
            this.state = { form: JSON.parse(local) }
        } else {
            this.state = { form: localStorageSettings }
        }
    }
    onChange(key, value) {
        this.setState({
            form: {
                ...this.state.form,
                [key]: value
            }
        }, () => this.saveToLocal());
        this.doChange(key, value);
    }
    doChange(key, value) {
        if(key === 'creatLinkFromUrls') {
            if(value) {
                this.creatLinkFromUrls();
            } else {
                this.removeLink();
            }
        }
    }
    creatLinkFromUrls() {
        window.pdfui.eventEmitter.emit('creatAllLinks');
    }
    removeLink() {
        window.pdfui.eventEmitter.emit('removeAllLinks');
    }
    saveToLocal() {
        const form = this.state.form;
        window.localStorage.setItem(localStorageKey, JSON.stringify(form));
    }
    render() {
        const { 
                form: {
                    singleKey,
                    fixedResolution,
                    resolution,
                    handSelectText,
                    handReadArticles,
                    handUseMouseZoom,
                }
            } = this.state;
        return (
            <>
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.title' })}</div>
                <Row className="board">
                    <Col span={24} className="mb_10">
                        <Checkbox
                            checked={singleKey}
                            onChange={e => this.onChange('singleKey', e.target.checked)}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.singleKey' }) }
                        </Checkbox>
                    </Col>
                    <Col span={15} className="mb_10">
                        <Checkbox
                            checked={fixedResolution}
                            onChange={e => this.onChange('fixedResolution', e.target.checked)}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.fixedResolution' }) }
                        </Checkbox>
                    </Col>
                    <Col span={4} className="mb_10">
                        { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.resolution' }) }:
                    </Col>
                    <Col span={5} className="mb_10">
                        <InputNumber 
                            value={resolution} 
                            min={1}
                            max={720}
                            onChange={val => this.onChange('resolution', val)} 
                            size="small"
                            disabled={!fixedResolution}
                        />
                    </Col>
                    <Col span={24} className="mb_10">
                        <Checkbox
                            checked={handSelectText}
                            onChange={e => this.onChange('handSelectText', e.target.checked)}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.handSelectText' }) }
                        </Checkbox>
                    </Col>
                    <Col span={24} className="mb_10">
                        <Checkbox
                            checked={handReadArticles}
                            onChange={e => this.onChange('handReadArticles', e.target.checked)}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.handReadArticles' }) }
                        </Checkbox>
                    </Col>
                    <Col span={24} className="mb_10">
                        <Checkbox
                            checked={handUseMouseZoom}
                            onChange={e => this.onChange('handUseMouseZoom', e.target.checked)}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.GeneralTab.basicTools.handUseMouseZoom' }) }
                        </Checkbox>
                    </Col>
                </Row>
            </>
        )
    }
}
